<template>
  <custom-dialog
    :openDialog="isOpen"
    :widthDialog="'800px'"
    :classDialog="'create-dialog custome-dialog'"
    @closeDialog="$emit('closeDialog')"
    @closed="$emit('dialogClosed')"
  >
    <!--    <template #header>-->
    <!--      <h3 class="dialogTitle">Tìm kiếm nâng cao</h3>-->
    <!--    </template>-->

    <template #header>
      <h5 class="dialogTitle margin-left-10">
        Báo cáo thực hiện công việc trọng tâm
      </h5>
    </template>

    <template #body>
      <el-form
        :model="form"
        ref="form"
        label-position="left"
        label-width="150px"
      >
        <el-row :gutter="24">
          <el-col :span="16">
            <el-form-item label="Thời gian chỉ đạo" class="formItem">
              <el-date-picker
                v-model="commandsDateRange"
                type="daterange"
                format="dd/MM/yyyy"
                class="style-fullWidth input-border__bottom input-border__radius__0"
                :picker-options="dateQuickFilterOption"
                range-separator="_"
                start-placeholder="_"
                end-placeholder="_"
                align="right"
                clearable
                @change="commandsDateRangeChanged"
                size="medium"
              ></el-date-picker>
            </el-form-item>
          </el-col>

          <el-col :span="24">
            <el-form-item label="Đơn vị" class="formItem">
              <el-select
                class="style-fullWidth input-border__bottom input-border__radius__0"
                v-model="form.performDepartmentIds"
                placeholder="Đơn vị"
                size="medium"
                filterable
                clearable
                multiple
              >
                <el-option
                  v-for="item in listDept"
                  :key="item.id"
                  :label="item.deptName"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>

        </el-row>
      </el-form>
    </template>

    <template #footer>
      <div class="flex-row flex__right form-button__action">
        <el-button class="dialogBtnPrimary" @click="exportReportExcel">
          <i class="fa fa-file-excel" aria-hidden="true"></i>
          &nbsp;Xuất Excel
        </el-button>
        <el-button class="btn__cancel btn-none__border" @click="resetForm"
          >Khởi tạo</el-button
        >
      </div>
    </template>
  </custom-dialog>
</template>

<script>
import constants from "../../../constants";
import dateUtils from "../../../dateUtils";
import dateFormatter from "../../../filters/dateFormatter";
import hanhchinhService from "../../../services/hanhchinhService";
import utils from "../../../services/utils";
import CustomDialog from "../../common/custom-dialog";

export default {
  name: "hc-command-report-dialog",
  components: { CustomDialog },
  filters: { dateFormatter },
  props: ["isOpen", "inputForm", "parentDeptId", "inputPageable"],

  computed: {
    userDeptRole() {
      return this.$store.getters.userDeptRole;
    },

    userDeptRoleId() {
      return this.$route.params.userDeptRoleId;
    }
  },

  data() {
    return {
      form: {
        fromCommandsDate: null,
        toCommandsDate: null,
        performDepartmentIds: null,
        progressStatus: null
      },
      departments: null,
      commandsDateRange: null,
      dateQuickFilterOption: null,
      // hcFlow: null,
      pageable: { sort: null, order: null },
      listDept: [],
    };
  },

  async created() {
    this.initDateQuickFilterOption();
    this.loadDepartments();
    this.initQuery();
  },

  methods: {
    resetForm() {
      this.initQuery();
    },

    loadDepartments() {
      return hanhchinhService.getDept(this.parentDeptId).then(response => {
        this.listDept = (response.data.departments || []).sort((dept1, dept2) =>
          dept1.deptName.localeCompare(dept2.deptName)
        );
      });
    },

    initDateQuickFilterOption() {
      this.dateQuickFilterOption = {
        shortcuts: [
          utils.buildDateQuickFilterOption(
            constants.DATE_QUICK_FILTER.CODE.THIS_MONTH
          ),
          utils.buildDateQuickFilterOption(
            constants.DATE_QUICK_FILTER.CODE.LAST_MONTH
          ),
          utils.buildDateQuickFilterOption(
            constants.DATE_QUICK_FILTER.CODE.NAM_NAY
          )
        ]
      };
    },

    commandsDateRangeChanged() {
      utils.timeRangeChanged(this.commandsDateRange, (from, to) => {
        this.form.fromCommandsDate = from;
        this.form.toCommandsDate = to;
      });
    },

    initQuery() {
      this.form = utils.merge(this.form, this.inputForm);
      this.pageable = utils.merge(this.pageable, this.inputPageable);
      this.initCommandsDateRange();
    },

    initCommandsDateRange() {
      if (this.form.fromCommandsDate && this.form.toCommandsDate) {
        this.commandsDateRange = [
          dateUtils.toMoment(this.form.fromCommandsDate),
          dateUtils.toMoment(this.form.toCommandsDate)
        ];
      } else {
        this.commandsDateRange = dateUtils.getDatesByQuickFilter(
          constants.DATE_QUICK_FILTER.CODE.THIS_MONTH_2
        );
        let defaultTimeRange = dateUtils.getTimesByQuickFilter(
          constants.DATE_QUICK_FILTER.CODE.THIS_MONTH_2
        );
        this.form.fromCommandsDate = defaultTimeRange[0];
        this.form.toCommandsDate = defaultTimeRange[1];
      }
    },

    validate() {
      return new Promise(resolve => {
        resolve();
      });
    },

    exportReportExcel() {
      let query = utils.merge(this.form, {
        userDeptRoleId: this.userDeptRoleId,
        sort: [this.pageable.sort, this.pageable.order].join(",")
      });
      let baseServiceURL = constants.BASE_SERVICE_URL;
      let reportUrl = constants.REPORT.HC_CONGVIECTRONGTAM.BAO_CAO_URL;
      window.open(
        `${baseServiceURL}${reportUrl}?${utils.serialize(query)}`,
        "_blank "
      );
    }
  }
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/views/report/congviectrongtam/hc-congviectrongtam-report-dialog.vue